import * as React from 'react';
import Grid from '@telia-front/grid';
import { GridCollapseContext } from '..';
const GridCollapse = (props) => {
    const { children, className } = props;
    const { gridStyle, gridRef, setAnimated, initialColumnCount, isOpen, setActualColumnCount } = React.useContext(GridCollapseContext);
    React.useEffect(() => {
        /* istanbul ignore else */
        if (setActualColumnCount) {
            setActualColumnCount(Array.isArray(children) ? children.length : 0);
        }
    }, [children, setActualColumnCount]);
    const onTransitionEnd = (event) => {
        // only trigger animation end action if height transition finishes on grid element
        /* istanbul ignore else */
        if (gridRef && event.target === gridRef.current && event.propertyName === 'height') {
            /* istanbul ignore else */
            if (setAnimated) {
                setAnimated();
            }
        }
    };
    const getInitialColumns = () => {
        if (Array.isArray(children) && children.length > initialColumnCount) {
            return children.slice(0, initialColumnCount);
        }
        return initialColumnCount > 0 ? children : null;
    };
    const BEM = () => {
        const classArray = ['grid-collapse'];
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (React.createElement(Grid, Object.assign({}, props, { className: BEM(), gridRef: gridRef, style: gridStyle, onTransitionEnd: onTransitionEnd }), isOpen ? children : getInitialColumns()));
};
export default GridCollapse;
